import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import BulkInvoicesContainer from '../../containers/accounting/BulkInvoices';
import Transition from './Transition';

const styles = () => ({
	dialogPaper: {
		width: '80%',
	},
	row : {
		paddingBottom : 10,
	},
	label : {
		marginRight : 10,
	},
	value : {
		fontWeight : 600,
	},
	current : {

	},
	new : {
		marginTop : 20,
	},
	section : {
		margin : '30px 0px 10px 0px',
		textAlign : 'left',
	},
	sectionHeader : {
		textTransform : 'uppercase',
		fontSize : 14,
		color : '#777',
		fontWeight : 900,
		letterSpacing : 2,
	},
});

class ViewBulkInvoiceLogDialog extends Component {
	constructor (props) {
		super(props);
		this.state = {};
	}

	componentDidUpdate(prevProps) {

		const { open, bulkInvoice, bulkInvoiceLogs, searchBulkInvoiceLogs } = this.props;

		if (
			open
			&& prevProps.open !== open
			&& bulkInvoice
			&& _.isEmpty(bulkInvoiceLogs)
		) {
			const { bulkInvoiceId } = bulkInvoice;
			searchBulkInvoiceLogs({
				bulkInvoiceId
			});
		}
	}

	handleClose = () => {
		this.props.onClose();
	};

	render() {
		const {
			classes,
			bulkInvoice,
			bulkInvoiceLogs,
		} = this.props;

		if (!bulkInvoice || !bulkInvoiceLogs) { return null; }

		const logs = bulkInvoiceLogs.map(r => {
			r.dateCreatedFormatted = moment(r.dateCreated).format('M/D h:mm a');
			return r;
		});

		const { bulkInvoiceId } = bulkInvoice;

		return (
			<div>
				<Dialog
					classes={{paper : classes.dialogPaper}}
					maxWidth='md'
					open={this.props.open}
					TransitionComponent={Transition}
					onClose={this.handleClose}
				>
					<DialogTitle>
						Bulk Invoice Id {bulkInvoiceId}
					</DialogTitle>
					<DialogContent>
						<div className={classes.section}>
							<div className={classes.sectionHeader}>Logs</div>
						</div>
						{logs.map((log, i) => {
							return (
								<div key={i} className={classes.row}>
									<span className={classes.label}>
										<strong>{log.dateCreatedFormatted}</strong> - {log.entry}
									</span>
								</div>
							);
						})}

					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleClose}>
							Close
						</Button>
					</DialogActions>
				</Dialog>
			</div>
		);
	}
}

ViewBulkInvoiceLogDialog.propTypes = {
	open : PropTypes.bool,
	onClose : PropTypes.func.isRequired,

	bulkInvoice : PropTypes.object,
	searchBulkInvoiceLogs : PropTypes.func.isRequired,
	bulkInvoiceLogs : PropTypes.array,

	history : PropTypes.object,
	classes: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles),
	BulkInvoicesContainer,
])(ViewBulkInvoiceLogDialog);